import React, { useState, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Dialog, Toast } from 'react-vant'
import { type FreezeModalProps, FreezeActionType } from './index.type'
import CustomButton from '@/components/CustomButton'
import { APIWeb } from '@/api/index'

const FreezeModal: React.FC<FreezeModalProps> = ({
  freezeActionType,
  visible,
  onClose,
  onFreezeAction
}) => {
  const { t } = useTranslation()
  const [loading, setLoading] = useState(false)

  // 根据操作类型获取弹窗内容
  const modalContent = useMemo(() => {
    if (freezeActionType === FreezeActionType.Freeze) {
      return {
        title: t('冻结卡片'),
        description: t('这将暂停所有线上线下及ATM交易冻结后使用卡片将产生拒绝交易费您可以随时解冻以恢复使用'),
        buttonText: t('冻结'),
      }
    } else {
      return {
        title: t('解冻卡片'),
        description: t('解冻后您的卡片将恢复正常使用可以进行线上线下及ATM交易'),
        buttonText: t('解冻'),
      }
    }
  }, [freezeActionType, t])

  // 处理冻结/解冻操作
  const handleConfirm = async () => {
    setLoading(true)
    try {
      if (freezeActionType === FreezeActionType.Freeze) {
        await APIWeb.freezeCard()
        Toast.success(t('卡片冻结成功'))
      } else {
        await APIWeb.unfreezeCard()
        Toast.success(t('卡片解冻成功'))
      }
      
      // 调用父组件的回调函数，通常用于刷新卡片状态
      onFreezeAction()
      onClose()
    } catch (error) {
      console.error('操作失败:', error)
      Toast.fail(freezeActionType === FreezeActionType.Freeze ? t('冻结失败，请重试') : t('解冻失败，请重试'))
    } finally {
      setLoading(false)
    }
  }

  return (
    <Dialog
      visible={visible}
      onClose={onClose}
      closeable={true}
      showCancelButton={false}
      showConfirmButton={false}
      closeOnClickOverlay={!loading}
      width="90%"
    >
      <div className="text-center px-6 py-8">
        <div className="text-xl font-500 text-black mb-4 break-all px-5">{modalContent.title}</div>
        <div className="text-base text-gray-600 mb-6 whitespace-pre-line leading-relaxed" dangerouslySetInnerHTML={{ __html: modalContent.description }} />
        
        {/* 操作按钮 */}
        <div className="flex justify-center items-center space-x-3">
          <CustomButton
            loading={loading}
            disabled={loading}
            onClick={handleConfirm}
            color={freezeActionType === FreezeActionType.Freeze ? 'danger' : 'primary'}
          >
            {modalContent.buttonText}
          </CustomButton>
        </div>
      </div>
    </Dialog>
  )
}

export default FreezeModal